<div class="dragdrop-container">
  <!-- Toolbox -->
  <div class="list-scroll-container" style="width: 100%;">
    <app-post-toolbox (buttonAction)="onButtonAction($event)"></app-post-toolbox>
  </div>

  <!-- Loading spinner shown while PostService.loading is true -->
  <div *ngIf="postLoading$ | async" style="padding-top: 300px;height: calc(100vh - 245px);">
    <app-loading></app-loading>
  </div>

  <!-- Main content (hidden while loading) -->
  <div *ngIf="!(postLoading$ | async)" class="post-main" style="height: calc(100vh - 245px);">
    <!-- <div class="mb-3"> -->
    <div class="mb-1">
      <p class="mb-0" title="Choose a ZIP file to send below in drag and drop area">Choose a ZIP file to send</p>
    </div>

    <!-- Selected file display -->
    <div *ngIf="selectedFile" class="mb-3 mt-1" [ngClass]="{ 'has-error': !validationResult.ok }">
      <div class="file-row">
        <div class="flex-grow-1">
          <input
            class="form-control fileInputTextControl"
            type="text"
            [class.is-invalid]="!validationResult.ok"
            [value]="selectedFile?.name ?? ''"
            [title]="selectedFile?.name ?? ''"
            readonly
          />
          <!-- Error message under the input -->
          <div *ngIf="!validationResult.ok" class="invalid-feedback" style="display:block;">
            {{ validationResult.message}}
          </div>
        </div>
        <span class="file-size ms-2">({{ formatFileSize(selectedFile.size) }})</span>
        <button
          type="button"
          class="btn btn-link p-0 view-icon-btn ms-2"
          title="View selected file"
          (click)="openFileInNewWindow()"
          aria-label="View selected file"
        >
          <i class="pi pi-eye icon black" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- file selection row with dropzone -->
    <div class="dragdrop-box"
         [class.dragover]="isDragOver"
         (dragover)="onDragOver($event)"
         (dragenter)="onDragEnter($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         role="button"
         tabindex="0"
         aria-label="Drop a ZIP file here or press Enter/Space to open the file picker"
         (keydown)="onDropzoneKeydown($event)">

      <!-- Hidden native file input -->
      <input type="file" id="postFile"
             #fileInput style="display: none"
             (change)="onFileSelected($event)"
             [accept]="'.zip'" />

      <div class="dragdrop-content">
        <div class="dragdrop-icon">
          <i class="pi pi-upload me-2 fs-5" style="color: #6c757d;"></i>
        </div>
        <p>
          Click <span (click)="triggerFilePicker()" class="browse">here</span>
          to select a ZIP file, or drag and drop one ZIP file into this area (maximum size {{ formatFileSize(this.maxZipFileByteSize, 0) }}).
        </p>
      </div>
    </div>
  </div>
</div>